<template>
  <div class="relative mt-1">
    <!-- Parent Button -->
    <button
      class="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200
             text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800"
      :class="collapsed ? 'justify-center px-2' : ''"
      @click="toggle"
    >
      <component :is="icon" class="w-5 h-5 text-slate-500 dark:text-slate-400" />
      <span v-if="!collapsed" class="truncate">{{ title }}</span>

      <svg
        v-if="!collapsed"
        xmlns="http://www.w3.org/2000/svg"
        class="w-4 h-4 ml-auto transition-transform duration-200"
        :class="open ? 'rotate-180' : ''"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.08 1.04l-4.25 4.25a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <!-- Expanded Mode (Normal Menu) -->
    <transition name="fade-slide">
      <div v-show="open && !collapsed" class="pl-3 mt-1 overflow-visible">
        <div class="px-2 py-2 space-y-1 bg-white border shadow-sm rounded-xl border-slate-200/70 dark:border-slate-700/60 dark:bg-slate-800/70">
          <slot :force-expanded="true" />
        </div>
      </div>
    </transition>

    <!-- Flyout Mode (Collapsed Sidebar) -->
    <Teleport to="#app">
      <transition name="fade-flyout">
        <div
          v-if="open && collapsed"
          ref="flyout"
          class="fixed w-60 py-3 px-3 rounded-2xl shadow-xl shadow-slate-900/10
                 border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900
                 z-[9999] pointer-events-auto"
          :style="{ top: flyoutTop, left: flyoutLeft }"
        >
          <slot :force-expanded="true" />
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    icon: { type: [Object, String, Function], default: null },
    collapsed: { type: Boolean, default: false },
    modelValue: { type: Boolean, default: true },
  },
  data() {
    return {
      flyoutTop: '0px',
      flyoutLeft: '85px',
    }
  },
  computed: {
    open: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) },
    },
  },
  mounted() {
    document.addEventListener('click', this.closeFlyout)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeFlyout)
  },
  methods: {
    toggle() {
      this.open = !this.open

      if (this.open && this.collapsed) {
        this.$nextTick(() => {
          const rect = this.$el.getBoundingClientRect()
          this.flyoutTop = rect.top + 'px'
          this.flyoutLeft = rect.left + 75 + 'px'
        })
      }
    },
    closeFlyout(e) {
      if (this.collapsed && this.open && this.$refs.flyout &&
          !this.$refs.flyout.contains(e.target) && !this.$el.contains(e.target)) {
        this.open = false
      }
    },
  },
}
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active { transition: all 0.2s ease-out; }
.fade-slide-enter-from,
.fade-slide-leave-to { opacity: 0; transform: translateY(-4px); }

.fade-flyout-enter-active,
.fade-flyout-leave-active { transition: all 0.15s ease-out; }
.fade-flyout-enter-from,
.fade-flyout-leave-to { opacity: 0; transform: translateX(-6px); }
</style>
